import config from '@/config';
import http from '@/utils/request';

export default {
  protal: {
    login: {
      url: `${config.API_URL}/base/hrms/protal/login`,
      name: "登录获取TOKEN",
      post: async function (data = {}) {
        return await http.post(this.url, data)
      }
    },
    log: {
      list: {
        url: `${config.API_URL}/base/hrms/protal/log/page`,
        name: '获取日志信息',
        get: async function (params, config) {
          config = Object.assign({ codeFlag: true }, config)
          return await http.post(this.url, params, config);
        },
      },
    },
    generateCaptcha: {
      url: `${config.API_URL}/base/hrms/protal/captcha/generate`,
      name: '获取验证码',
    },
    checkCaptcha: {
      url: `${config.API_URL}/base/hrms/protal/captcha/check`,
      name: '校验验证码',
    }
  },
  company: {
    list: {
      url: `${config.API_URL}/base/hrms/company/find`,
      name: '获取公司信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    save: {
      url: `${config.API_URL}/base/hrms/company/toSave`,
      name: '新增公司信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    update: {
      url: `${config.API_URL}/base/hrms/company/toUpdate`,
      name: '修改公司信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
  },
  dept: {
    list: {
      url: `${config.API_URL}/base/hrms/depart/findTreeList`,
      name: '获取部门信息',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    save: {
      url: `${config.API_URL}/base/hrms/depart/save`,
      name: '新增部门信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    update: {
      url: `${config.API_URL}/base/hrms/depart/update`,
      name: '修改部门信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    remove: {
      url: `${config.API_URL}/base/hrms/depart/remove`,
      name: '删除部门信息',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
  },
  role: {
    list: {
      url: `${config.API_URL}/base/hrms/role/page`,
      name: '获取角色信息',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    findList: {
      url: `${config.API_URL}/base/hrms/role/findList`,
      name: '获取角色',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    findListAndUsers: {
      url: `${config.API_URL}/base/hrms/role/findListAndUsers`,
      name: '获取角色及下面的用户列表',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    save: {
      url: `${config.API_URL}/base/hrms/role/save`,
      name: '新增角色信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    update: {
      url: `${config.API_URL}/base/hrms/role/update`,
      name: '修改角色信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    changeStatus: {
      url: `${config.API_URL}/base/hrms/role/status/change`,
      name: '修改角色状态',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    remove: {
      url: `${config.API_URL}/base/hrms/role/remove`,
      name: '删除角色信息',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    removeBatch: {
      url: `${config.API_URL}/base/hrms/role/removeBatch`,
      name: '批量删除角色信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    authConfig: {
      url: `${config.API_URL}/base/hrms/role/auth/config`,
      name: '角色授权初始化',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    authSave: {
      url: `${config.API_URL}/base/hrms/role/auth/save`,
      name: '角色授权保存',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    }
  },
  user: {
    list: {
      url: `${config.API_URL}/base/hrms/user/page`,
      name: '获取员工列表',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    find: {
      url: `${config.API_URL}/base/hrms/user/findById`,
      name: '查询一个员工详情',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    findLogin: {
      url: `${config.API_URL}/base/hrms/user/findLoginUser`,
      name: '查询一个员工详情',
      get: async function () {
        return await http.get(this.url, {});
      },
    },
    save: {
      url: `${config.API_URL}/base/hrms/user/save`,
      name: '新增员工信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    update: {
      url: `${config.API_URL}/base/hrms/user/update`,
      name: '修改员工信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    updateLoginMsg: {
      url: `${config.API_URL}/base/hrms/user/updateLoginUser`,
      name: '修改登录员工资料信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    rePwd: {
      url: `${config.API_URL}/base/hrms/user/rePwd`,
      name: '重置员工密码',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    rePwdBatch: {
      url: `${config.API_URL}/base/hrms/user/rePwdBatch`,
      name: '批量重置员工密码',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    changeStatus: {
      url: `${config.API_URL}/base/hrms/user/status/change`,
      name: '修改员工状态',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    remove: {
      url: `${config.API_URL}/base/hrms/user/remove`,
      name: '删除员工',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    removeBatch: {
      url: `${config.API_URL}/base/hrms/user/removeBatch`,
      name: '批量删除员工',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    authConfig: {
      url: `${config.API_URL}/base/hrms/user/auth/config`,
      name: '用户授权初始化',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    authSave: {
      url: `${config.API_URL}/base/hrms/user/auth/save`,
      name: '用户授权保存',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    findSite: {
      url: `${config.API_URL}/base/hrms/user/site/findLoginUserSite`,
      name: '查询一个员工设置',
      get: async function () {
        return await http.get(this.url, {});
      },
    },
    siteSave: {
      url: `${config.API_URL}/base/hrms/user/site/save`,
      name: '用户设置维护',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    changeDefaultPwd: {
      url: `${config.API_URL}/base/hrms/user/changeDefaultPwd`,
      name: '用户修改默认密码',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    changePwd: {
      url: `${config.API_URL}/base/hrms/user/changePwd`,
      name: '用户修改密码',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    }
  },

  site: {
    list: {
      url: `${config.API_URL}/base/hrms/company/site/page`,
      name: '获取配置列表',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    save: {
      url: `${config.API_URL}/base/hrms/company/site/save`,
      name: '新增配置信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    update: {
      url: `${config.API_URL}/base/hrms/company/site/update`,
      name: '修改配置信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    remove: {
      url: `${config.API_URL}/base/hrms/company/site/remove`,
      name: '删除配置',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
  },

  view: {
    list: {
      url: `${config.API_URL}/base/hrms/company/view/page`,
      name: '获取视图列表',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    findByCode: {
      url: `${config.API_URL}/base/hrms/company/view/config/findByCode`,
      name: '获取视图列表',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    save: {
      url: `${config.API_URL}/base/hrms/company/view/save`,
      name: '保存视图信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    saveConfig: {
      url: `${config.API_URL}/base/hrms/company/view/config/save`,
      name: '保存视图信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
  },

  dict: {
    findTalentAll: {
      url: `${config.API_URL}/base/hrms/dic/talent/findAll`,
      name: '获取人才字典列表',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    findCompanyAll: {
      url: `${config.API_URL}/base/hrms/dic/company/findAll`,
      name: '获取公司字典列表',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    findProjectAll: {
      url: `${config.API_URL}/base/hrms/dic/project/findAll`,
      name: '获取项目字典列表',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    findByCode: {
      url: `${config.API_URL}/base/hrms/dic/findByTypeCode`,
      name: '获取一个类型的字典列表',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
    page: {
      url: `${config.API_URL}/base/hrms/dic/page`,
      name: '获取字典列表',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    pageTree: {
      url: `${config.API_URL}/base/hrms/dic/pageTree`,
      name: '获取字典树',
      get: async function (params, config) {
        config = Object.assign({ codeFlag: true }, config)
        return await http.post(this.url, params, config);
      },
    },
    findTreeByTypeCodes: {
      url: `${config.API_URL}/base/hrms/dic/findTreeByTypeCodes`,
      name: '获取多个类型的字典树',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    save: {
      url: `${config.API_URL}/base/hrms/dic/save`,
      name: '新增配置信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    update: {
      url: `${config.API_URL}/base/hrms/dic/update`,
      name: '修改字典信息',
      post: async function (params) {
        return await http.post(this.url, params);
      },
    },
    remove: {
      url: `${config.API_URL}/base/hrms/dic/remove`,
      name: '删除字典信息',
      get: async function (params) {
        return await http.get(this.url, params);
      },
    },
  }
};
